export default "__VITE_ASSET__22cc10af__"